import React, {Component} from 'react';
import Registry from '../../../registry/index';

import './styles.scss';

class RoomSendButton extends Component {
    render() {
        let lang = Registry.get('locale');

        return (<a id="button-send" className={this.props.disabled ? 'disabled' : ''} onClick={this.props.onClick}>{lang.send}</a>);
    }
}

export default RoomSendButton;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/RoomSendButton/index.js